import { type RouteObject, createBrowserRouter } from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';
import { routerConfig } from './routerConfig';

export const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    children: routerConfig as RouteObject[],
  },
]);
